import { useState } from 'react'
import { Box, Text, Checkbox, Label } from 'theme-ui'
import Counter from './Counter'
import PlusIcon from '../../icons/PlusFat'
import MinusIcon from '../../icons/MinusFat'

export default function FilterToggle({
    name,
    toggleName,
    count,
    checked,
    onChange,
    icon,
}) {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <Box
                sx={{
                    height: 52,
                    display: 'flex',
                    alignItems: 'center',
                    borderBottomColor: 'border',
                    borderBottomWidth: 1,
                    borderBottomStyle: 'solid',
                    cursor: 'pointer',
                }}
                onClick={() => setIsOpen(!isOpen)}
            >
                <Box
                    sx={{
                        mr: 2,
                        display: 'flex',
                    }}
                >
                    {icon}
                </Box>
                <Text
                    sx={{
                        fontSize: 1,
                        flex: 1,
                        textTransform: 'uppercase',
                    }}
                >
                    {name}
                </Text>
                {checked && <Counter total={1} />}
                {isOpen ? <MinusIcon /> : <PlusIcon />}
            </Box>
            {isOpen && (
                <Box
                    sx={{
                        borderBottomColor: 'border',
                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        py: 3,
                    }}
                >
                    <Label>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                height: 30,
                            }}
                        >
                            <Box>
                                <Checkbox
                                    checked={checked}
                                    value={name}
                                    onChange={onChange}
                                />
                            </Box>
                            <Text
                                sx={{
                                    fontSize: 1,
                                    display: 'flex',
                                    color: 'textDarkGrey',
                                    flex: 1,
                                    textTransform: 'uppercase',
                                }}
                            >
                                {toggleName} ({count})
                            </Text>
                        </Box>
                    </Label>
                </Box>
            )}
        </>
    )
}
